export class ServerError extends Error {
  code: number | string;
  serverMessage?: string;
  constructor (code: number | string, message: string, serverMessage?: string) {
    super(message);
    this.code = code;
    this.serverMessage = serverMessage;
  }
}
